<template>
  <v-dialog v-model="dialog" scrollable max-width="700">
    <v-card flat hover>
      <v-card-title>
        <v-spacer />
        <IconButton
          v-if="deleteBtnFlg"
          icon="mdi-delete"
          @click="openConfirmDialog"
        />
        <IconButton icon="mdi-reload" @click="getNice" />
        <IconButton icon="mdi-close" @click="agree" />
      </v-card-title>

      <v-card-text>
        <div class="row mx-auto">
          <div class="col-12" align="center">
            <Avatar :src="this.item.TO_USER_AVATER" :size="130" />
          </div>
          <div class="col-12">
            <h3 class="text-center mt-0">
              To {{ item.TO_USER_NAME
              }}<small>({{ item.TO_USER_POSITION }})</small>
            </h3>
          </div>
          <div class="col-12">
            <strong style="white-space: pre-wrap; word-wrap: break-word">{{
              this.item.SEND_COMMENT
            }}</strong>
          </div>
        </div>

        <div class="row mx-auto">
          <div class="col-12" align="right">
            <Avatar :src="this.item.SEND_USER_AVATER" :size="80" />
            <h3 class="text-right mt-2">
              From {{ item.SEND_USER_NAME
              }}<small>({{ item.SEND_USER_POSITION }})</small>
            </h3>
          </div>

          <div class="col-12" align="right">
            <IconButton
              icon="mdi-thumb-up"
              @click="sendNice"
              color="orange darken-2"
            />

            <div class="balloon" align="left">
              <span class="number"
                >いいね！<strong v-show="niceFlg">{{
                  this.niceCnt
                }}</strong></span
              >
            </div>
          </div>
        </div>

        <NiceList v-if="this.niceFlg" :niceList="niceList" />

        <div align="center" class="my-2">
          <Button
            v-if="replyBtnFlg"
            @click="onClickReplySendOpen()"
            color="primary"
            >返信</Button
          >
        </div>
      </v-card-text>

      <Loader :loading="loading" />

      <DialogMessage ref="dialog" />

      <send ref="send"></send>

      <ConfirmDialog
        ref="confirm"
        :title="messegeDialogWord"
        :message="confirmMessage"
        buttonMessage="OK"
        @confirm="delete_comment"
      />
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import config from '../../../const.js';
import message from '../../../message.js';
import send from '@/components/pages/Encouragements/SendDialog.vue';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem } from '@/common.js';
import NiceList from '@/components/pages/Encouragements/NiceList.vue';

export default {
  components: {
    send,
    ConfirmDialog,
    NiceList,
  },
  data: () => ({
    // 変数宣言
    loading: false,
    dialog: false,
    resolve: null,
    reject: null,
    replyBtnFlg: true,
    deleteBtnFlg: true,
    confirmMessage: null,
    messegeDialogWord: null,

    niceFlg: false,
    niceCnt: 0,
    replyFlg: config.REPLY_FLG_OFF,
    options: {
      color: 'primary',
      width: 350,
    },
    item: {},
    // 自分自身のプラスの氣取得
    items: null,
    niceList: null,
  }),
  methods: {
    open(item) {
      this.item = item;
      this.dialog = true;

      // 返信メッセージ判定
      if (item.REPLY_FLG == null) {
        this.replyFlg = config.REPLY_FLG_OFF;
      } else {
        this.replyFlg = item.REPLY_FLG;
      }
      if (this.replyFlg == config.REPLY_FLG_OFF) {
        this.messegeDialogWord = config.PURASUNOKI_MESSAGE_WORD + '削除';
      } else {
        this.messegeDialogWord = config.REPLY_MESSAGE_WORD + '削除';
      }

      // 返信・削除ボタン表示制御
      let userInfo = getSessionStorageItem();
      if (this.item.SEND_USER_NAME == userInfo.USER_NAME) {
        this.replyBtnFlg = false;
        this.deleteBtnFlg = true;
      } else {
        this.replyBtnFlg = true;
        this.deleteBtnFlg = false;
      }

      // いいねのアコーディオン
      this.niceCnt = 0;
      this.niceFlg = false;

      // いいね情報取得
      this.getNice();

      //this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    sendNice() {
      //ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // いいねチェック（同じユーザが再度、いいねできない制御）
      var sendNiceFlg = false;
      if (this.niceCnt > 0) {
        for (var i = 0; i < this.niceList.length; i++) {
          if (this.niceList[i].NICE_USER_ID == userInfo.USER_ID) {
            sendNiceFlg = true;
            break;
          }
        }
      }
      if (sendNiceFlg) {
        this.$refs.dialog.open('info', message.MSG_INFO_NICE_TWO_NG);
        return;
      }

      // 自分自身のコメントにいいねをできない制御
      if (this.item.SEND_USER_ID == userInfo.USER_ID) {
        this.$refs.dialog.open('info', message.MSG_INFO_NICE_SELF_NG);
        return;
      }

      // ローディング画像表示
      this.loading = true;
      // いいね情報作成
      let niceTime = moment().format('YYYYMMDDHHmmss');

      //----- いいね！送信リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/sendNice', {
          SESSION_ID: userInfo.SESSION_ID,
          SEND_KEY: this.item.SEND_KEY,
          NICE_TIME: niceTime,
          ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
          NICE_USER_ID: userInfo.USER_ID,
          NICE_USER_NAME: userInfo.USER_NAME,
          NICE_USER_NAME_FURIGANA: userInfo.USER_NAME_FURIGANA,
          NICE_USER_POSITION: userInfo.POSITION_NAME,
          NICE_USER_AVATER: userInfo.USER_AVATER,
          NICE_START_WORKING_AT: userInfo.START_WORKING_AT,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          if (response.status == 200) {
            this.items = response.data;
            this.niceList = this.items[0].NICE_LIST;
            this.niceCnt = this.niceList.length;
            if (this.niceCnt > 0) {
              this.niceFlg = true;
            }

            // アバター接続URL作成
            for (var i = 0; i < this.niceList.length; i++) {
              this.niceList[i].NICE_USER_AVATER =
                config.S3_END_POINT +
                config.AVATER_DIRECTORY +
                this.niceList[i].NICE_USER_AVATER +
                '?' +
                moment().format('YYYYMMDDHHmmss');
            }
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    getNice() {
      // ローディング画像表示
      this.loading = true;
      //ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      //----- いいね取得リクエストGET
      axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/getNice/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            this.item.SEND_KEY
        )
        .then((response) => {
          this.niceList = response.data;
          this.niceCnt = this.niceList.length;
          if (this.niceCnt > 0) {
            this.niceFlg = true;
          }

          // アバター接続URL作成
          for (var i = 0; i < this.niceList.length; i++) {
            this.niceList[i].NICE_USER_AVATER =
              config.S3_END_POINT +
              config.AVATER_DIRECTORY +
              this.niceList[i].NICE_USER_AVATER +
              '?' +
              moment().format('YYYYMMDDHHmmss');
          }
          // ローディング画像終了
          this.loading = false;
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else if (error.response.status == 404) {
            // いいね情報が存在しないため、何もしない
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
          // ローディング画像終了
          this.loading = false;
        });
    },
    onClickReplySendOpen() {
      //ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      this.$refs.send.open(
        userInfo.ORGANIZATION_KEY,
        this.item.SEND_USER_ID,
        this.item.SEND_USER_NAME,
        this.item.SEND_USER_NAME_FURIGANA,
        this.item.SEND_USER_POSITION,
        this.item.SEND_USER_AVATER,
        this.item.SEND_START_WORKING_AT,
        config.REPLY_FLG_ON,
        { color: 'red' }
      );
    },
    openConfirmDialog() {
      // 確認ダイアログ表示
      if (this.replyFlg == config.REPLY_FLG_OFF) {
        this.confirmMessage =
          this.item.TO_USER_NAME +
          'さんへの' +
          config.PURASUNOKI_MESSAGE_WORD +
          'を削除しますか？';
      } else {
        this.confirmMessage =
          this.item.TO_USER_NAME +
          'さんへの' +
          config.REPLY_MESSAGE_WORD +
          'を削除しますか？';
      }

      this.$refs.confirm.open();
    },
    delete_comment() {
      // ローディング画像表示
      this.loading = true;

      //ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      //----- プラスの氣削除リクエストDELETE
      axios
        .delete(
          config.CONNECT_URL +
            '/Encouragements/comment/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            this.item.SEND_KEY
        )
        .then((response) => {
          let msgStr = '';
          if (response.status == 200) {
            if (this.replyFlg == config.REPLY_FLG_OFF) {
              // プラスの氣削除完了メッセージ
              msgStr =
                this.item.TO_USER_NAME +
                message.MSG_INFO_DELETE_PURASUNOKI_COMPLETE;
            } else {
              // 返信メッセージ削除完了メッセージ
              msgStr =
                this.item.TO_USER_NAME +
                message.MSG_INFO_DELETE_REPLY_MESSAGE_COMPLETE;
            }
            this.$refs.dialog.open('info', msgStr);
          }
          // ローディング画像終了
          this.loading = false;
          this.agree();
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
          // ローディング画像終了
          this.loading = false;
        });

      // ローディング画像終了
      this.loading = false;
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
      this.niceFlg = false;
      this.$emit('detail');
    },
  },
};
</script>
<style>
/*吹き出し*/
.balloon {
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
}

.balloon span.number {
  color: #777;
  font-size: 90%;
  line-height: 2em;
  padding: 5px 10px;

  position: relative;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.balloon span.number:after,
.balloon span.number:before {
  right: 100%;
  top: 50%;
  border: solid transparent;
  content: '';
  position: absolute;
}

.balloon span.number:after {
  border-right-color: #fff;
  border-width: 4px;
  margin-top: -4px;
}

.balloon span.number:before {
  border-right-color: #ccc;
  border-width: 5px;
  margin-top: -5px;
}

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 0.5rem;
  border-top: 5px solid #e55513;
}
</style>
